import { Workflow } from './workflow';
import { WorkflowValidityReport } from './workflow-validity-report';

/**
 * Représente le résultat d'une requête de mise à jour d'un workflow.
 */
export class WorkflowUpdateResult {
    /**
     * Instance du workflow mis à jour ou null si la mise à jour n'a pas été effectué du fait que le workflow est invalide.
     */
    updatedWorkflow: Workflow = null;

    /**
     * Rapport de validation du workflow.
     */
    validityReport: WorkflowValidityReport = null;

    /**
     * Retourne une copie d'une instance de WorkflowUpdateResult
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: WorkflowUpdateResult) {
        if (!!other) {
            const instance = new WorkflowUpdateResult();
            instance.updatedWorkflow = Workflow.clone(other.updatedWorkflow);
            instance.validityReport = WorkflowValidityReport.clone(other.validityReport);

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de WorkflowUpdateResult
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: WorkflowUpdateResult[]) {
        if (!!others) {
            let reports: WorkflowUpdateResult[] = [];

            others.forEach((x) => {
                const report = WorkflowUpdateResult.clone(x);
                reports.push(report);
            });

            return reports;
        } else {
            return [];
        }
    }
}
